@if (!showPreview && !disconect) {
  <div class="scanner-container d-flex flex-column justify-content-between">
    <!-- Header -->
    <div class="scanner-header">
      <button class="close-button me-4" (click)="openModal(confirmation);"><img src="assets\images\icons\cross-close.svg"
      alt=""></button>
      <h2>Scan Driving License</h2>
      <p>Kindly scan the barcode on the back of your driver's license</p>
    </div>
    <!-- Video + Frame -->
    <div class="scanner-video-wrapper">
      <video class="scanner-video" #videoElement preload="auto" muted playsinline autoplay></video>
      <!-- Scanning frame (corners and barcode box) -->
      <div class="scanner-frame">
        <div class="corner top-left"></div>
        <div class="corner top-right"></div>
        <div class="corner bottom-left"></div>
        <div class="corner bottom-right"></div>
      </div>
    </div>
    <!-- Security Footer -->
    <div class="scanner-footer  ">
      <div class="shield-icon"><img src="assets\images\icons\Vector.svg" alt=""></div>
      <p>Your information is secured and used solely to support your financing application.</p>
    </div>
  </div>
}






<!-- <button (click)="stopScanner()" *ngIf="scanning">Stop Scanner</button>
<button (click)="startScanner()" *ngIf="!scanning">Start Scanner</button>
<button (click)="showPreview=showPreview?false:true">Preview</button> -->

<!-- <div style="position: relative; width: 100%; height: auto;" *ngIf="!showPreview">
<video #videoElement width="100%" height="auto" autoplay></video>
<div style="position: absolute; top: 40%; left: 5%; width: 50%; height: 30%; border: 2px dashed rgb(0, 247, 255); pointer-events: none;"></div>
</div>
<button (click)="stopScanner()" *ngIf="scanning">Stop Scanner</button>
<button (click)="startScanner()" *ngIf="!scanning">Start Scanner</button>
<button (click)="showPreview=showPreview?false:true">Preview</button> -->

@if (showPreview && !disconect) {
  <div class="finance-wrapper vh-95" [ngClass]="{'coverLoader': hideCommonLoader}">
    <div class="plans-header d-flex align-items-center justify-content-between px-4 py-3 border-bottom">
      <img src="assets\images\icons\FM-logo-green.svg" alt="">
    </div>
    <div class="finance-inner overflow-hidden position-relative">
      <div class="finance-body overflow-auto p-4  d-flex justify-content-center">
        @if (showPreview && !hideCommonLoader && !showDone ) {
          <div class="customer-form mxw-780">
            <h4 class="fs-20 fw-800 mb-1">
              Additional Information Required
            </h4>
            <p class="fs-16 fw-600 text-muted mb-4">
              To proceed with the financing application, please provide the following details:
            </p>
            <form action="" [formGroup]="previewForm" autocomplete="patient-form">
              <div class="row">
                <!-- <div class="col-xs-6 col-sm-4 mb-2">
                <div class="input_container">
                  <input type="text" class="input_field" placeholder="" name="first_name" formControlName="first_name"
                    id="detail_1" autocomplete="patient-first-name">
                    <label for="" class="input_label">First Name</label>
                  </div>
                  <p class="mat-error text-danger w-100 d-block mb-0 fs-12"
                    *ngIf="previewForm.controls['first_name'].touched && previewForm.controls['first_name'].invalid">
                    Please enter valid first name
                  </p>
                </div> -->
                <!-- <div class="col-xs-6 col-sm-4 mb-2">
                <div class="input_container">
                  <input type="text" class="input_field" placeholder="" name="last_name" formControlName="last_name"
                    id="detail_2" autocomplete="patient-last-name">
                    <label for="" class="input_label">Last Name</label>
                  </div>
                  <p class="mat-error text-danger w-100 d-block mb-0 fs-12"
                    *ngIf="previewForm.controls['last_name'].touched && previewForm.controls['last_name'].invalid">
                    Please enter valid last name
                  </p>
                </div> -->
                <!-- <div class="col-xs-6 col-sm-4 mb-2">
                <app-date-of-birth [dobSubscription]="dobSubscription" [dobData]="dobData"
                [fromPage]="'contractCreation'" (submittedData)="getDob($event)"></app-date-of-birth>
                <p class="mat-error text-danger w-100 d-block mb-0 fs-12" *ngIf="showDobError">
                Please enter valid date of birth</p>
              </div> -->
              <!-- <div class="col-12 mb-2">
              <app-google-zip class="w-100" (setAddress)="getZipselected($event)" id="zipPostalCode"
                [country_code]="'US'" [address]="previewForm.controls['address'].value" [floatLable]="true">
              </app-google-zip>
              <p class="mat-error text-danger w-100 d-block mb-0 fs-12"
                *ngIf="previewForm.controls['address'].touched && previewForm.controls['address'].invalid">
              Please enter valid address</p>
            </div> -->
            <!-- <div class="col-12 mb-2">
            <div class="input_container">
              <input type="text" class="input_field w-100" placeholder="" formControlName="address_line_2"
                id="address_2" autocomplete="patient-address-line-2" name="address_2">
                <label for="" class="input_label">Building / Unit Number or Apartment Name</label>
              </div>
              <p class="mat-error text-danger w-100 d-block mb-0 fs-12"
                *ngIf="previewForm.controls['address_line_2'].touched && previewForm.controls['address_line_2'].invalid">
                Please enter valid Address
              </p>
            </div> -->
            <!-- <div class="col-xs-4 col-sm-2 mb-2">
            <div class="input_container">
              <input [readonly]="!enableZip" type="text" class="input_field" placeholder="" formControlName="zip"
                name="zip_code" id="zip_code">
                <label for="" class="input_label">Zip Code</label>
              </div>
              <p class="mat-error text-danger w-100 d-block mb-0 fs-12"
                *ngIf="previewForm.controls['zip'].touched && previewForm.controls['zip'].invalid">
                Please enter valid zip code
              </p>
            </div> -->
            <!-- <div class="col-xs-4 col-sm-2 mb-2">
            <div class="input_container">
              <input readonly type="text" class="input_field" placeholder="" formControlName="city" id="city"
                name="city">
                <label for="" class="input_label">City</label>
              </div>
            </div> -->
            <!-- <div class="col-xs-4 col-sm-2 mb-2">
            <div class="input_container">
              <input readonly type="text" class="input_field w-100" placeholder="" id="state"
                formControlName="state" name="state">
                <label for="" class="input_label">State</label>
              </div>
            </div> -->
            <div class="col-12">
              <div class="d-flex w-100">
                <span
                  class="d-flex justify-content-center align-items-center border border-end-0 left-tb-border hw-56">
                  {{display_logo}}
                </span>
                <div class="input_container flex-fill">
                  <input type="text" inputmode="decimal" class="input_field w-100 left-tb-border remove"
                    formControlName="monthly_income" autocomplete="off" id="customer_mobile_number" placeholder=" "
                    mask="separator.2" thousandSeparator="," name="monthly_income"
                    (blur)="formatMonthlyIncome(previewForm, 'monthly_income')" required>
                    <label class="input_label">Monthly Income</label>
                  </div>
                </div>
                @if (previewForm.controls['monthly_income'].touched && previewForm.controls['monthly_income'].invalid) {
                  <p class="mat-error text-danger w-100 d-block mb-0 fs-12"
                    >
                    Please enter monthly income
                  </p>
                }
              </div>
              <div class="col-12 mb-2">
                <div class="input_container">
                  <input type="text" inputmode="decimal" class="input_field w-100 fw-400" placeholder=" "
                    [mask]="SSNmask" name="social_security_number" formControlName="social_security_number"
                    id='social_security_number' autocomplete="off">
                    <label for="" class="input_label">Social Security Number</label>
                  </div>
                  @if (
                    previewForm.controls['social_security_number']?.touched &&
                    previewForm.controls['social_security_number']?.invalid
                    ) {
                    @switch (true) {
                      @case ($safeNavigationMigration(previewForm.controls['social_security_number']?.errors?.['required'])) {
                        <p class="mat-error text-danger w-100 d-block mb-0 fs-12"
                          >
                          SSN is required
                        </p>
                      }
                      @case ($safeNavigationMigration(previewForm.controls['social_security_number']?.errors?.['ssnInvalid'])) {
                        <p class="mat-error text-danger w-100 d-block mb-0 fs-12"
                          >
                          Please enter a valid social security number
                        </p>
                      }
                    }
                  }
                </div>
                <div class="col-12 my-4 mt-1">
                  <div class="d-flex px-3 py-2 radius-8 border border-success align-items-center">
                    <img src="assets/images/icons/shield-security.svg" alt="" class="me-2 hw-24">
                    <div>
                      <h4 class="fs-14 fw-600 text-success m-0 mb-1">
                        Why do we need SSN?
                      </h4>
                      <p class="fs-12 fw-400 m-0">
                        We require the Social Security Number (SSN) to securely verify the identity and protect against
                        fraudulent activity. Your information is secure and never shared. We use it for verification
                        purposes.
                      </p>
                    </div>
                  </div>
                </div>
                <button (click)="sumbitScanData()" [disabled]=" previewForm.invalid" class="btn btn-secondary fw-700"
                  id="continue_2">
                  Submit
                </button>
              </div>
            </form>
          </div>
        }
        @if (hideCommonLoader) {
          <div class="mxw-450 d-flex align-items-center justify-content-center flex-column text-center"
            >
            <span class="element mb-5 d-flex hw-140 position-relative rounded-circle overflow-hidden">
              <span
                class="position-center d-flex justify-content-between align-items-center hw-135 bg-white rounded-circle">
                <img src="assets/images/icons/profile-circle.png" alt="" class="hw-80  mx-auto rounded-circle ">
              </span>
            </span>
            <p class="fs-18 fw-700 mxw-450 mx-auto ">
              Processing your information...
            </p>
            <p class="fs-16 fw-400 mxw-450 mx-auto ">
              Please wait while we securely retrieve and verify your details.
            </p>
          </div>
        }
        @if (showDone) {
          <div
            class="mxw-450 mt-5 d-flex align-items-center justify-content-center flex-column text-center">
            <span class="mb-2 d-flex hw-140 position-relative overflow-hidden">
              <span class="position-center d-flex justify-content-between align-items-center hw-135 bg-white">
                <img src="assets/images/icons/greenTick.svg" alt="" class="hw-100  mx-auto rounded-circle ">
              </span>
            </span>
            <p class="fs-24 fw-800 mxw-450 mx-auto ">
              Details Submitted!
            </p>
            <p class="fs-16 fw-600 mxw-450 mx-auto ">
              Your details have been submitted successfully. You can now continue on the web portal to complete the process.
            </p>
          </div>
        }
      </div>
    </div>
  </div>
}
@if (disconect) {
  <div class="finance-wrapper vh-96" [ngClass]="{'coverLoader': hideCommonLoader}">
    <div class="plans-header d-flex align-items-center justify-content-between px-4 py-3 border-bottom">
      <img src="assets\images\icons\FM-logo-green.svg" alt="">
    </div>
    <div class="finance-inner overflow-hidden position-relative">
      <div class="finance-body overflow-auto p-4 d-flex justify-content-center">
        <div class="mxw-450 d-flex align-items-center justify-content-center flex-column text-center">
          <img src="assets/images/icons/Process_discontinue.png" alt="" class="mb-5">
          <p class="fs-18 fw-700 mxw-450 mx-auto ">
            Process Discontinued...
          </p>
          <p class="fs-16 fw-400 mxw-450 mx-auto ">
            Please scan QR-Code again.
          </p>
        </div>
      </div>
    </div>
  </div>
}

<ng-template #confirmation>
  <div class="modal-dialog m-0 p-2 document">
    <div class="modal-header d-flex align-item-center justify-content-between border-0 p-4 pb-2">
      <h2 class="modal-title ml-auto fs-20 fw-700" id="exampleModalLabel">
        Cancel Scanning
      </h2>
    </div>
    <div class="modal-body ps-4 pt-0 pb-5">
      Do you want to leave this page?
    </div>
    <div class="modal-body fs-16 fw-500 p-3 pt-0 pb-1 row m-0">
      <button class="w-100 btn btn-outline text-black mx-1 border-grayish"
      (click)="closeInvalidConfirm()">Cancel</button>
    </div>
    <div class="modal-body fs-16 fw-500 p-3 pt-2 pb-2 row m-0">

      <button class="btn w-100 btn-secondary text-black mx-1" (click)="closeConfirmationModal()">Yes, I
      Confirm</button>
    </div>
  </div>
</ng-template>

<ng-template #confirmation1>
  <div class="modal-dialog m-0 p-2 document">
    <div class="modal-header d-flex align-item-center justify-content-between border-0 p-4 pb-2">
      <h2 class="modal-title ml-auto fs-20 fw-700" id="exampleModalLabel">
        Invalid Bar Code
      </h2>
    </div>
    <div class="modal-body ps-4 pt-0 pb-5">
      Please confirm if you want to scan again?
    </div>
    <div class="modal-body fs-16 fw-500 p-3 pt-0 pb-1 row m-0">
      <button class="w-100 btn btn-outline text-black mx-1 border-grayish" (click)="closeScannig()">Cancel</button>
    </div>
    <div class="modal-body fs-16 fw-500 p-3 pt-2 pb-2 row m-0">

      <button class="btn w-100 btn-secondary text-black mx-1" (click)="closeInvalidConfirm()">Yes, I
      Confirm</button>
    </div>
  </div>
</ng-template>





<!-- <zxing-scanner
[formats]="formats"
(scanSuccess)="onScanSuccess($event)"
(scanFailure)="onScanFailure($event)"
></zxing-scanner> -->